import React from 'react'
import { Link } from 'react-router-dom';
import { doctor03 } from '../../imagepath';
import Breadcrumb from '../../ui/Breadcrumb';
import { useAuth } from '../../../contexts/AuthContext';

const Profile = () => {
  const { user } = useAuth();
  const fullName = [user?.name, user?.lastname].filter(Boolean).join(' ');
  const role = user?.doctor?.specialty?.name || user?.profile?.name;

  return (
    <>
    <div className="row">
      <div className="col-sm-7 col-6">
        <Breadcrumb items={[{ label: 'Inicio', to: '/' }, { label: 'Mi Perfil' }]} />
      </div>
      <div className="col-sm-5 col-6 text-end m-b-30">
        <Link to="/edit-profile" className="btn btn-primary btn-rounded"><i className="fa fa-plus" /> Editar Perfil</Link>
      </div>
    </div>
    <div className="card profile-header">
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            <div className="profile-view">
              <div className="profile-img-wrap">
                <div className="profile-img">
                  <img className="avatar" src={doctor03} alt="Foto de perfil" />
                </div>
              </div>
              <div className="profile-basic">
                <div className="row">
                  <div className="col-md-5">
                    <div className="profile-info-left">
                      <h3 className="user-name m-t-0 mb-0">{fullName || 'Usuario'}</h3>
                      {role && <small className="text-muted">{role}</small>}
                    </div>
                  </div>
                  <div className="col-md-7">
                    <ul className="personal-info">
                      <li>
                        <span className="title">Correo Electrónico:</span>
                        <span className="text">{user?.email || '—'}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Profile
